export const DefaultLoader = () => (
  <div className="loading">
    <div className="loader" />
  </div>
);
